import { Card, CardBody, Table } from "reactstrap";
import moment from "moment";
import React from "react";
import { Col, Row} from "reactstrap";
import  { registerLocale } from "react-datepicker";
import nl from "date-fns/locale/nl";

registerLocale("nl", nl);

const PeriodeOverzicht = ({ arrTotal, startDate, endDate }) => {

    return (
        <>
            
            <div className="begindatum-datepicker-style">
                <Card className="main-card mb-3">
                    <CardBody>
                    <h6 class="head-text-color mb-2" style={{fontWeight: 600}}>Periode-overzicht</h6>
                        <Row>
                            <Col sm={6}>
                                <Table size="sm" className="mb-0 table table-bordered table-sm table-hover">
                                    <thead>
                                        <tr>
                                            <th>Periode</th>
                                            <th>Uren  totaal</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{moment(startDate).format('DD-MM-yyyy') + ' t/m ' + moment(endDate).format('DD-MM-yyyy')}</td>
                                            <td>{arrTotal['uren'] !== undefined ? Number(arrTotal['uren']).toFixed(2) : 0}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </div>
             
        </>
    );
};

export default PeriodeOverzicht;